

import { useState, useEffect } from 'react'
import { useUser } from '@/contexts/UserContext'
import { MentionsInput, Mention } from 'react-mentions'

export default function CommentMentionsInput({ value, onChange, onKeyDown, placeholder, inputRef }) {
    const { user } = useUser()
    const [data, setData] = useState([])

    useEffect(() => {
        if (user?.accountUsers) {
            setData(
                user.accountUsers.map(u => ({
                    id: u._id || u.id,
                    display: `${u.first_name} ${u.last_name}`,
                    email: u.email
                }))
            )
        }
    }, [user])

    return (
        <MentionsInput
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            inputRef={inputRef}
            style={{
                control: {
                    backgroundColor: 'transparent',
                    fontSize: 12,
                    fontWeight: 'normal',
                },
                '&multiLine': {
                    control: {
                        fontFamily: 'inherit',
                        minHeight: 34,
                    },
                    highlighter: {
                        padding: 9,
                        border: '1px solid transparent',
                    },
                    input: {
                        padding: 9,
                        border: '1px solid rgb(51, 53, 58)',
                        borderRadius: '5px',
                        outline: 'none',
                    },
                },
                mention: {
                    backgroundColor: 'blue',
                },
                suggestions: {
                    borderRadius: '5px',
                    overflow: 'hidden',
                    border: '1px solid rgb(51, 53, 58)',
                    list: {
                        backgroundColor: 'rgb(23, 24, 29)',
                        fontSize: 12,
                    },
                    item: {
                        padding: '5px',
                        borderBottom: '1px solid rgba(255,255,255,0.05)',
                        '&focused': {
                            color: 'rgb(0, 0, 0)',
                            backgroundColor: 'rgb(229,254,0)',
                        },
                    },
                },
            }}
        >
            <Mention
                markup='{{{"name":"__display__","id":"__id__"}}}'
                displayTransform={(id, display) => `${display}`}
                className='mention-highlight'
                trigger='@'
                data={data}
                appendSpaceOnAdd={true}
                renderSuggestion={(suggestion, search, highlightedDisplay) => (
                    <div>{highlightedDisplay}</div>
                )}
            />
        </MentionsInput>
    )
}
